import { put, select } from 'redux-saga/effects';

import { KnmVersionsEnum } from 'APIPackage/KnmModule/enums/KnmVersionsEnum';
import { IKnm } from 'APIPackage/KnmModule/interfaces/IKnm';
import { fetchKnm } from 'APIPackage/KnmModule/services/knmApi';
import { IResponseError } from 'APIPackage/MainModule/interfaces/IResponseError';
import { setLawInterfaceAction } from 'CorePackage/MainModule/actions/coreActions';
import { NOT_FOUND_ERROR } from 'CorePackage/MainModule/constants/httpErrors';
import {
  KNM_NOT_AVAILABLE_LINK_TO_PLAN_LESS_30_DAYS,
  KNM_NOT_FOUND_ERROR,
} from 'CorePackage/MainModule/constants/notices';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getLawInterface } from 'CorePackage/MainModule/reducers/coreReducer';
import { addNoticeAction } from 'CorePackage/NotificationModule/actions/NoticeActions';
import { MessageTypesEnum } from 'CorePackage/NotificationModule/enums/MessageTypesEnum';
import { NoticeTypesEnum } from 'CorePackage/NotificationModule/enums/NoticeTypesEnum';

import {
  knmAddVisibleModal,
  knmGetFailure,
  knmGetRequest,
  knmGetSuccess,
  knmSetAccessNoticeErpId,
  knmSetAccessNoticeKnoOrganizationName,
} from '../actions/knmActions';
import { KnmModalsEnum } from '../enums/KnmModalsEnum';

export function* knmFetchKnmSagaWithReturnKnm(knmId: number, onSuccess?: (data: IKnm) => void) {
  yield put(knmGetRequest());
  try {
    const data: IKnm = yield fetchKnm(knmId);
    const state: IRootState = yield select();
    const isErknm: boolean = yield getLawInterface(state) === LawInterfacesEnum.FZ_248;

    if (isErknm && (data.version === KnmVersionsEnum.ERP || data.version === null)) {
      yield put(setLawInterfaceAction(LawInterfacesEnum.FZ_294));
    } else if (!isErknm && data.version === KnmVersionsEnum.ERKNM) {
      yield put(setLawInterfaceAction(LawInterfacesEnum.FZ_248));
    }

    yield put(knmGetSuccess(data));
    if (onSuccess) {
      yield onSuccess(data);
    }
  } catch (err) {
    const error: IResponseError = err as IResponseError;

    yield put(knmGetFailure());
    const isNotFoundError = error.error === NOT_FOUND_ERROR;

    if (error.status === 403) {
      if (error?.message?.includes('ACCESS_DENIED_FOR_TEST')) {
        yield put(knmAddVisibleModal(KnmModalsEnum.ACCESS_DENIED_FOR_TEST));
      } else {
        yield put(knmSetAccessNoticeErpId(error.erpId));
        yield put(knmSetAccessNoticeKnoOrganizationName(error.knoOrganizationName));
        yield put(knmAddVisibleModal(KnmModalsEnum.ACCESS_RESTRICTION_NOTICE));
      }
    } else if (isNotFoundError) {
      yield put(
        addNoticeAction({
          renderContent: KNM_NOT_FOUND_ERROR,
          noticeType: NoticeTypesEnum.ERROR,
          messageType: MessageTypesEnum.KNM_NOT_FOUND,
        }),
      );
    } else if (error?.message?.includes('KNM_NOT_AVAILABLE_LINK_TO_PLAN')) {
      yield put(
        addNoticeAction({
          renderContent: KNM_NOT_AVAILABLE_LINK_TO_PLAN_LESS_30_DAYS,
          noticeType: NoticeTypesEnum.ERROR,
          messageType: MessageTypesEnum.ADD_KNM_TO_PLAN,
        }),
      );
    }
  }
}
